// src/pages/Fleet.js (güncel)
import React, { useMemo, useState } from "react";
import FLEET from "../data/fleet.json";
import { MetaIcon } from "../components/ServiceIcon";

export default function Fleet() {
  const [query, setQuery] = useState("");

  const list = useMemo(() => {
    const q = query.trim().toLowerCase();
    const base = [...FLEET];
    base.sort((a, b) => (b.rentable - a.rentable) || (b.year - a.year));
    if (!q) return base;
    return base.filter((m) =>
      [m.name, m.model, m.tonnage, String(m.year)]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(q))
    );
  }, [query]);

  const handleRowClick = (id) => {
    window.location.href = `/fleet/${id}`;
  };

  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">Araç Parkurumuz</h1>
          <p className="page-subtitle">Güncel makine ve kamyon envanteri.</p>
        </header>

        <div className="fleet-toolbar">
          <input
            className="fleet-search"
            type="search"
            placeholder="Model, tonaj veya yıl ara…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Araçlarda ara"
          />
          <div className="fleet-count" aria-live="polite">
            {list.length} kayıt
          </div>
        </div>

        <div className="fleet-list" role="table" aria-label="Araç listesi">
          <div className="fleet-head" role="row">
            <div className="fleet-th" role="columnheader">Araç</div>
            <div className="fleet-th" role="columnheader">Model</div>
            <div className="fleet-th" role="columnheader">Tonaj</div>
            <div className="fleet-th" role="columnheader">Yıl</div>
            <div className="fleet-th" role="columnheader">Öne Çıkanlar</div>
          </div>

          {list.map((m) => (
            <div
              key={m.id}
              className="fleet-row clickable-row"
              role="row"
              tabIndex={0}
              onClick={() => handleRowClick(m.id)}
              onKeyDown={(e) => e.key === "Enter" && handleRowClick(m.id)}
            >
              <div className="fleet-td" role="cell">
                <div className="fleet-title">
                  {m.name}
                  <span className="muted"> • {m.model}</span>
                </div>
              </div>
              <div className="fleet-td" role="cell">
                <span className="fleet-mono">{m.model}</span>
              </div>
              <div className="fleet-td" role="cell">{m.tonnage || "—"}</div>
              <div className="fleet-td" role="cell">
                <MetaIcon type="year" /> {m.year || "—"}
              </div>
              <div className="fleet-td" role="cell">
                <ul className="fleet-tags">
                  {(m.features || []).slice(0, 3).map((f, i) => (
                    <li key={i} className="tag">{f}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}